export default "__VITE_ASSET__LzLAUXGb__"